import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype/internal/keywords/keywords.ts'

import searchParamString from '@/utils/schema/searchParamString'

// import privateRoute from '@/auth/middleware/privateRoute'

const DEFAULT_VALUES = {
  q: '',
}

const chatSearchSchema = type({
  q: searchParamString.default(DEFAULT_VALUES.q),
})

export const Route = createFileRoute('/chat/')({
  validateSearch: chatSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
  // beforeLoad: ({context, location}) => {
  //   privateRoute(context.store, location.href)
  // },
})
